import { Component, Input } from '@angular/core';
import { Product } from '../../pages/produtos/produtos.modelview';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { DetalheProdutoPage } from '../../pages/detalhe-produto/detalhe-produto';
import { NavController } from 'ionic-angular';


/**
 * Generated class for the ProdutoItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'produto-item',
  templateUrl: 'produto-item.html'
})
export class ProdutoItemComponent {

  @Input() produto: Product;

  constructor(private inAppBrowser: InAppBrowser,
  private navCtrl: NavController) {
   
  }

  learnMore() {
    this.navCtrl.parent.push(DetalheProdutoPage, {
      model: this.produto
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/produto-item/produto-item.ts